import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUsageAudioCachedV1Response } from './get-usage-audio-cached-v1-response';
import { getUsageAudioCachedV1ResponseSchema } from './get-usage-audio-cached-v1-response';

export async function getUsageAudioCachedV1Api(
  slug: string,
): Promise<IValidatedResponse<IGetUsageAudioCachedV1Response>> {
  return getRequest<IGetUsageAudioCachedV1Response>({
    path: `/challenges/${slug}/audio/usage/cached/v1`,
    schema: getUsageAudioCachedV1ResponseSchema,
  });
}
